import Shopify from "../../../../contents/docs/cdp/sources/_snippets/source-shopify.mdx";
import * as React from 'react';
export default {
  Shopify,
  React
};